/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import UserService from 'mt-react-common/modules/users/services/UserService';
import { sendGetAuthAccountDataRequest } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';

class CancelEmailChangeRequestLink extends Component {
  cancelEmailChangeRequest = e => {
    e.preventDefault();
    this.props.setLoading(true);
    UserService.cancelEmailChangeRequest().then(result => {
      if (result) {
        console.log(result);
        this.props.sendGetAuthAccountDataRequest();
      }
      this.props.setLoading(false);
    });
  };

  render() {
    return (
      <div>
        <div
          aria-labelledby="myModalLabel"
          className="modal fade"
          id="modalConfirmCancelEmailChangeRequest"
          role="dialog"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-gray modal-sm">
            <div className="modal-content">
              <div className="modal-header text-center">
                <a
                  aria-label="Close"
                  className="close close-black"
                  data-dismiss="modal"
                  href=""
                />
                <i className="fa fa-exclamation-triangle modal-icon" />
                <h4 className="modal-title">
                  <strong>Подтверждение</strong>
                </h4>
              </div>
              <div className="modal-body text-center">
                Вы уверены, что хотите отменить задание на изменение адреса
                элктронной почты и оставить {this.props.authAccountData.email}.
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-muted"
                  data-dismiss="modal"
                  type="button"
                >
                  Отмена
                </button>
                <button
                  className="btn btn-primary"
                  data-dismiss="modal"
                  type="button"
                  onClick={this.cancelEmailChangeRequest}
                >
                  Подтвердить
                </button>
              </div>
            </div>
          </div>
        </div>
        <em>
          Если вы хотите оставить {this.props.authAccountData.email}, вы можете{' '}
          <a data-toggle="modal" href="#modalConfirmCancelEmailChangeRequest">
            отменить задание на смену адреса электронной почты
          </a>
        </em>
      </div>
    );
  }
}

CancelEmailChangeRequestLink.propTypes = {
  // IN
  authAccountData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    newEmail: PropTypes.string.isRequired,
    emailConfirm: PropTypes.number.isRequired
  }).isRequired,
  setLoading: PropTypes.func.isRequired,
  sendGetAuthAccountDataRequest: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  sendGetAuthAccountDataRequest: () => dispatch(sendGetAuthAccountDataRequest())
});

export default connect(
  () => {},
  mapDispatchToProps
)(CancelEmailChangeRequestLink);



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/_common/CancelEmailChangeRequestLink.js